import React from 'react'
import { Select } from '@st-operations/uikit/src/v2'

export const LOOKBACK_VALUES = {
  YESTERDAY: 'yesterday',
  WEEK_1: '1_week',
  MONTH_1: '1_month',
  MONTH_3: '3_months',
  MONTH_6: '6_months',
}

export const LOOKBACK_LABELS = {
  [LOOKBACK_VALUES.YESTERDAY]: 'Yesterday',
  [LOOKBACK_VALUES.WEEK_1]: '1 week',
  [LOOKBACK_VALUES.MONTH_1]: '1 month',
  [LOOKBACK_VALUES.MONTH_3]: '3 months',
  [LOOKBACK_VALUES.MONTH_6]: '6 months',
}

const LookbackSelect = ({
  className,
  classes,
  style,
  lookback,
  vertical,
  label = 'Lookback',
  onLookbackChange,
}) => {
  return (
    <Select
      className={className}
      classes={classes}
      style={{ ...style, ...(vertical ? { width: '100%' } : {}) }}
      label={label}
      options={[
        { label: LOOKBACK_LABELS[LOOKBACK_VALUES.YESTERDAY], value: LOOKBACK_VALUES.YESTERDAY },
        { label: LOOKBACK_LABELS[LOOKBACK_VALUES.WEEK_1], value: LOOKBACK_VALUES.WEEK_1 },
        { label: LOOKBACK_LABELS[LOOKBACK_VALUES.MONTH_1], value: LOOKBACK_VALUES.MONTH_1 },
        { label: LOOKBACK_LABELS[LOOKBACK_VALUES.MONTH_3], value: LOOKBACK_VALUES.MONTH_3 },
        { label: LOOKBACK_LABELS[LOOKBACK_VALUES.MONTH_6], value: LOOKBACK_VALUES.MONTH_6 },
      ]}
      value={lookback}
      onChange={({ value }) => onLookbackChange(value)}
      useReactSelect
    />
  )
}

export default LookbackSelect
